import {Draggable, Droppable} from "react-beautiful-dnd"
import styles from "./SectionItem.module.css"
import {ShiftItem} from "./ShiftItem"

const grid = 8

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    padding: 0,
    background: isDragging ? "lightgreen" : "transparent",
    ...draggableStyle
})

const getBackground = (isDraggingOver) => {
    return isDraggingOver ? "lightblue" : "#a5d3ff"
}

const getListStyle = (isDraggingOver) => ({
    background: getBackground(isDraggingOver),
    padding: grid
})

type Props = {
    phaseItem: any
    index: number
    shifts: Array<{
        shiftName: string
        shiftId: number
        academicTrackPhaseShiftTemplateShiftId: number
    }>
    reloadView: () => void
}

export function SectionItem(props: Props) {
    const {phaseItem, shifts, reloadView} = props

    return (
        <div>
            <Droppable droppableId={`${phaseItem.academicTrackPhaseShiftTemplateId}`}>
                {(provided, snapshot) => (
                    <div>
                        <div className={styles.termCourseSectionBody}>
                            <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                {shifts.map((shift, index) => (
                                    <Draggable
                                        isDragDisabled
                                        key={shift.shiftId}
                                        draggableId={`${phaseItem.academicTrackPhaseShiftTemplateId}_${shift.academicTrackPhaseShiftTemplateShiftId}_${shift.shiftId}`}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}>
                                                <ShiftItem key={index} shift={shift} reloadView={reloadView} />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    </div>
                )}
            </Droppable>
        </div>
    )
}
